import { useSelector } from 'react-redux';
import { HasPermission } from 'Core/security';
import { isCerebrumx } from '../../utils/rawDataAccess';
import { REMOTE_COMMANDS_PERMISSION, REMOTE_COMMANDS_USER_CODE } from '../constants';

/**
 * Whether the unit gets the Remote commands tabs: a CerebrumX unit and the
 * `remotecommands` permission (P3-53958) — on the account role together with
 * its parent `oemdata`, plus userCode 380 for a sub-user. Deliberately not
 * `canViewOemData`, which lets every unit through when `oem-raw-data-cbx-only` is off.
 */
export const useRemoteCommandsAccess = ({ manufacturerName }) => {
	const user = useSelector((state) => state.securityRedux?.user);
	const allowed =
		isCerebrumx(manufacturerName) && HasPermission(user, [REMOTE_COMMANDS_PERMISSION], [REMOTE_COMMANDS_USER_CODE]);
	return { allowed };
};
